const COUNTRY_EN = {
    'españa': 'Spain',   'espana': 'Spain',    'espagne': 'Spain',
    'alemania': 'Germany', 'deutschland': 'Germany',
    'francia': 'France',
    'italia': 'Italy',
    'bélgica': 'Belgium', 'belgica': 'Belgium',
    'holanda': 'Netherlands', 'países bajos': 'Netherlands',
    'suiza': 'Switzerland',
    'reino unido': 'United Kingdom',
    'estados unidos': 'USA', 'united states': 'USA',
    'brasil': 'Brazil',
    'perú': 'Peru',
    'méxico': 'Mexico',
    'letonia': 'Latvia',
    'eslovenia': 'Slovenia',
    'eslovaquia': 'Slovakia',
    'rumania': 'Romania', 'rumanía': 'Romania',
    'república checa': 'Czech Republic',
    'tailandia': 'Thailand',
    'turquía': 'Turkey', 'turquia': 'Turkey',
};

const ISO_TO_NAME = {
    'af':'Afghanistan','ad':'Andorra','ar':'Argentina','au':'Australia','at':'Austria',
    'be':'Belgium','bo':'Bolivia','br':'Brazil','cl':'Chile','co':'Colombia',
    'cr':'Costa Rica','hr':'Croatia','cz':'Czech Republic','do':'Dominican Republic',
    'ec':'Ecuador','es':'Spain','fr':'France','de':'Germany','gb':'United Kingdom',
    'hu':'Hungary','in':'India','it':'Italy','jp':'Japan','lv':'Latvia',
    'mx':'Mexico','nl':'Netherlands','ni':'Nicaragua','no':'Norway','pe':'Peru',
    'pl':'Poland','pt':'Portugal','ro':'Romania','ru':'Russia','sk':'Slovakia',
    'si':'Slovenia','za':'South Africa','ch':'Switzerland','th':'Thailand',
    'tr':'Turkey','ua':'Ukraine','us':'USA','uy':'Uruguay','ve':'Venezuela',
};

export function normalizeCountry(c) {
    if (!c) return 'Unknown';
    const iso = ISO_TO_NAME[c.toLowerCase()] ?? ISO_TO_NAME[c.toUpperCase()?.toLowerCase()];
    if (iso) return iso;
    return COUNTRY_EN[c.toLowerCase()] ?? c;
}

const countryMap = {
    // Full names
    'Afghanistan':'af','Andorra':'ad','Argentina':'ar','Australia':'au','Austria':'at',
    'Belgium':'be','Bolivia':'bo','Brazil':'br','Chile':'cl','Colombia':'co',
    'Costa Rica':'cr','Croatia':'hr','Czech Republic':'cz','Dominican Republic':'do',
    'Ecuador':'ec','España':'es','Spain':'es','France':'fr',
    'Germany':'de','Hungary':'hu','India':'in','Italy':'it',
    'Japan':'jp','Latvia':'lv','Mexico':'mx','Netherlands':'nl',
    'Nicaragua':'ni','Norway':'no','Peru':'pe','Poland':'pl',
    'Portugal':'pt','Romania':'ro','Russia':'ru','Slovakia':'sk','Slovenia':'si',
    'South Africa':'za','Switzerland':'ch','Thailand':'th','Turkey':'tr','Türkiye':'tr',
    'Turkiye':'tr','Ukraine':'ua',
    'United Kingdom':'gb','United States':'us','USA':'us',
    'Uruguay':'uy','Venezuela':'ve','Indonesia':'id',
    // ISO uppercase
    'AR':'ar','AT':'at','BE':'be','BO':'bo','BR':'br','CH':'ch','CL':'cl',
    'CO':'co','CR':'cr','CZ':'cz','DE':'de','DO':'do','EC':'ec','ES':'es',
    'FR':'fr','GB':'gb','GB-SCT':'gb','HR':'hr','HU':'hu','IT':'it','JP':'jp',
    'LV':'lv','MX':'mx','NI':'ni','NL':'nl','NO':'no','PE':'pe','PL':'pl',
    'PT':'pt','RO':'ro','RU':'ru','SK':'sk','SI':'si','TH':'th','TR':'tr','UA':'ua',
    'US':'us','UY':'uy','VE':'ve','ZA':'za','ID':'id',
    // ISO lowercase
    'ar':'ar','at':'at','be':'be','bo':'bo','br':'br','ch':'ch','cl':'cl',
    'co':'co','cr':'cr','cz':'cz','de':'de','do':'do','ec':'ec','es':'es',
    'fr':'fr','gb':'gb','hr':'hr','hu':'hu','it':'it','jp':'jp',
    'lv':'lv','mx':'mx','ni':'ni','nl':'nl','no':'no','pe':'pe','pl':'pl',
    'pt':'pt','ro':'ro','ru':'ru','sk':'sk','si':'si','th':'th','tr':'tr','ua':'ua',
    'us':'us','uy':'uy','ve':'ve','za':'za','id':'id',
};

export function countryFlag(country) {
    const code = countryMap[country];
    if (!code) return country ?? '';
    return [...code.toUpperCase()].map(c => String.fromCodePoint(c.charCodeAt(0) + 127397)).join('');
}
